$(document).ready(function() {
    // Resize the button arrow so that it's always round
    // long titles on the buttons 

    $('.button__arrow').each(function() {
        // set width to match height
        var height = $(this).height();
        $(this).css({'minWidth': height});

        // calc right based on height (keep centered)
        var right = (height - 24) / 2;
        $(this).children('span').css({'right': right});
    });
});